import { PageType } from '../../common/AnalyticsContext/TrackingData';
import { TrackingEvent } from '../../common/AnalyticsContext/TrackingEvent';
import { useAnalytics } from '../../common/AnalyticsContext/useAnalytics';
import { useEffectOnceOnMount } from '../../common/hooks/useEffectOnceOnCondition';
import {
  ErrorView,
  StyledImage,
  Header,
  Subheader,
  Message,
  Links,
  StyledLink,
} from './Error.styles';

interface Props {
  error: unknown;
}

const USER_MESSAGE = 'Something went wrong. We are on it!';

export const Error = ({ error }: Props) => {
  const { trackEvent } = useAnalytics({
    pageData: {
      pageType: PageType.ERROR,
      error: { type: String(error), message: USER_MESSAGE },
    },
  });

  useEffectOnceOnMount(() => trackEvent(TrackingEvent.ERROR_PAGE_LOADED));

  return (
    <ErrorView>
      <StyledImage />
      <Header>Uh oh!</Header>
      <Subheader>{USER_MESSAGE}</Subheader>

      <Message>
        Oooops, looks like the page you are trying to reach is not available. Check the URL or try
        the following links to find the health answers you want:
      </Message>

      <Links>
        <StyledLink to="/appointments/gp/">GP Appointments</StyledLink>
        <StyledLink to="/appointments/find/gp/Australia">Find Doctors</StyledLink>
        <StyledLink to="/appointments/after-hours/gp/">After Hours GP Appointments</StyledLink>
        <StyledLink to="/appointments/bulk-billing-gp/">Bulk Billing GP Appointments</StyledLink>
        <StyledLink to="/appointments/dentist/">Dentist Appointments</StyledLink>
        <StyledLink to="/appointments/physiotherapist/">Physiotherapist Appointments</StyledLink>
        <StyledLink to="/appointments/chiropractor/">Chiropractor Appointments</StyledLink>
        <StyledLink to="/appointments/psychologist/">Psychologist Appointments</StyledLink>
      </Links>
    </ErrorView>
  );
};
